import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  select: (props: { padding?: string }) => ({
    '& #accountselect': {
      padding: `${props.padding}`, // Dynamic padding
    },
  }),
}));


interface AccountDropdownProps {
    accounts: any;
    selectedAccount: any;
    handleAccountChange: any;
    width?: string;
    padding?: string;
}

export const AccountDropdown: React.FC<AccountDropdownProps> = ({ accounts, selectedAccount, handleAccountChange, width, padding }) => {
    const classes = useStyles({padding});

    return (
        <Select variant="outlined" className={classes.select}
        id='accountselect'
            value={selectedAccount?.id}
            onChange={(e) => handleAccountChange(e)}
            style={{
                border: '1px solid #ccc',
                borderRadius: '4px',
                width: width || 'auto',
                alignItems: 'center', 
                justifyContent: 'space-between', 
            }}
        >
            {accounts?.map((role: any) => (
                <MenuItem value={role.id} key={role.id}>
                    {role.name}
                </MenuItem>
            ))}
        
        </Select>
    );
}
